import HomeIcon from "@material-ui/icons/Home";
import InfoIcon from "@material-ui/icons/Info";
import NewReleasesIcon from "@material-ui/icons/NewReleases";
import { IRoute } from "src/common/typings/routes";
import { AuthModule } from "./AuthModule";
import { ForgotPassword, LoginPage, RegisterPage } from "./pages";
import { CreatePasswordPage } from "./pages/CreatePasswordPage";
import { SetPasswordPage } from "./pages/SetPasswordPage";
import { ChangePasswordPage } from "../change-password/pages/ChangePassword";

export const AuthRoute: IRoute = {
  title: "Auth Module",
  path: "/auth",
  icon: HomeIcon,
  component: AuthModule,
  subRoutes: [
    { icon: InfoIcon, component: LoginPage, path: "/login", title: "Auth Login" },
    {
      icon: InfoIcon,
      component: ChangePasswordPage,
      path: "/change-password",
      title: "Change Password",
    },
    { icon: NewReleasesIcon, component: RegisterPage, path: "/register", title: "Auth Register" },
    { icon: NewReleasesIcon, component: ForgotPassword, path: "/forgot", title: "Forgot Password" },
    {
      icon: NewReleasesIcon,
      component: CreatePasswordPage,
      path: "/create-password",
      title: "Create Password",
    },
    {
      icon: NewReleasesIcon,
      component: SetPasswordPage,
      path: "/set-password",
      title: "set Password",
    },
  ],
};
